import { Box, Grid, MenuItem } from "@material-ui/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Field } from "redux-form";

import {
  createLogEntryPayload,
  withTrackProps,
} from "@dpdgroupuk/react-event-tracker";

import HeaderWithStar from "../../../../components/HeaderWithStar/HeaderWithStar";
import SelectWithTitle from "../../../../components/SelectWithTitle/SelectWithTitle";
import { PROFILE_ANALYTICS } from "../../../../constants/analytics";
import {
  OUTBOUND_SERVICE,
  PLEASE_SELECT_SERVICE,
} from "../../../../constants/strings";
import { getDpdLocalInternationalServices } from "../../../../features/config/config.selectors";
import { DEFAULT_DPD_LOCAL_INTERNATIONAL_OUTBOUND_SERVICE_FIELD } from "../../../../features/profile/profile.constants";
import { getInternationalDpdLocalValue } from "../../../../features/profile/profile.selectors";
import { renderSelectItems } from "./DefaultsDpd";
import styles from "./DefaultsDpd.module.scss";

const DefaultsDpdLocalInternational = ({
  dpdLocalInternationalServices,
  internationalDpdLocalValue,
  onDropdownClick,
}) => (
  <Box width="80%" className={styles.wrapper}>
    <Grid
      container
      justify="space-between"
      alignItems="center"
      className={styles.spacing}
    >
      <HeaderWithStar
        text={OUTBOUND_SERVICE}
        required={!!internationalDpdLocalValue}
      />
      <Grid item className={styles.select}>
        <Field
          name={DEFAULT_DPD_LOCAL_INTERNATIONAL_OUTBOUND_SERVICE_FIELD}
          component={SelectWithTitle}
          displayEmpty
          showMetaErrors
          onClick={() => {
            onDropdownClick(
              DEFAULT_DPD_LOCAL_INTERNATIONAL_OUTBOUND_SERVICE_FIELD
            );
          }}
        >
          <MenuItem value={""}>{PLEASE_SELECT_SERVICE}</MenuItem>
          {renderSelectItems(dpdLocalInternationalServices)}
        </Field>
      </Grid>
    </Grid>
  </Box>
);

DefaultsDpdLocalInternational.propTypes = {
  onDropdownClick: PropTypes.func,
  dpdLocalInternationalServices: PropTypes.array,
  internationalDpdLocalValue: PropTypes.bool,
};

export default compose(
  connect(
    (state) => ({
      dpdLocalInternationalServices: getDpdLocalInternationalServices(state),
      internationalDpdLocalValue: getInternationalDpdLocalValue(state),
    }),
    null
  ),
  withTrackProps(() => ({
    onDropdownClick: (field) =>
      createLogEntryPayload(PROFILE_ANALYTICS.CLICK_DROPDOWN_LIST, {
        field,
      }),
  }))
)(DefaultsDpdLocalInternational);
